import { publicEnvConfig } from 'helpers/env';
import { ScriptLoader } from 'helpers/scriptLoader';

const RecaptchaV3 = ({ id }) => {
	const siteKey = publicEnvConfig.RECAPTCHA_V3_SITE_KEY;
	if (!siteKey) return null;

	const url = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
	return <ScriptLoader id={id} url={url} />;
};

export default RecaptchaV3;
